import type { NitroFetchRequest, $Fetch } from 'nitropack'
import type { FetchOptions } from 'ofetch'
import type { GetTagAllResponse } from '~/types/apis/v3/getTagAll'

export const tagRepository = <T>(fetch: $Fetch<T, NitroFetchRequest>) => ({
  async getTagAll(
    options: FetchOptions & {
      params?: {
        all?: boolean
        sort_by?: string
        order_by?: 'asc' | 'desc'
        per_page?: number
        page?: number
        search?: string,
        has_color?: boolean
      }
    } = {}
  ): Promise<GetTagAllResponse> {
    return fetch<GetTagAllResponse>(`/v3/storefront/tag`, {
      ...options,
      method: 'GET'
    })
  }
})

